import cx from 'clsx';
import React from 'react';
import { useController, useWatch } from 'react-hook-form';

import RadioButtonsGroup from '@components/form/RadioButtonsGroup/RadioButtonsGroup';
import Select from '@components/uikit/Select/Select';
import Switch from '@components/uikit/Switch/Switch';

import { DATETIME_FORMATS } from '@constants/datetimeFormats';

import useTranslation from '@hooks/useTranslation';

import { useChartsTypesListQuery } from '@services/useChartsTypesListQuery';
import { useUserProfileQuery } from '@services/user/useUserProfileQuery';

import { USER_FIELDS } from '../../constants/schemaUser';
import { getRoleAndPermissionsList } from '../../helpers/getRoleAndPermissionsList';
import style from './style.module.scss';

const StepRegionAndPermissions = ({ user, control, timezoneList }) => {
  const { t } = useTranslation();

  const { data: profileData } = useUserProfileQuery();
  const { data: chartTypeListData } = useChartsTypesListQuery({
    select: (data) => Object.values(data).filter((type) => type.personalSettings),
  });

  const [metric] = useWatch({ control, name: [USER_FIELDS.USE_METRIC] });

  const hasViewSensorDataPermission = profileData?.userAccess?.manageSensorData;

  const metricsList = [
    { value: 0, label: t('Metric (mm, mm/sec, °C)') },
    { value: 1, label: t('US (mils, in/sec, °F)') },
    // { value: 2, label: t('Custom') },
  ];

  const dateTimeList = [
    { value: DATETIME_FORMATS.us.dateTime, label: t('MM/DD/YY HH:mm:ss') },
    { value: DATETIME_FORMATS.common.dateTime, label: t('DD/MM/YY HH:mm:ss') },
  ];

  const roleAndPermissionList = getRoleAndPermissionsList(profileData?.role);

  const {
    field: { value: roleValue, onChange: roleChange },
  } = useController({ name: USER_FIELDS.ROLE, control });

  const checkDisabledRole = (role) => {
    const profileRole = profileData.role;

    if (
      role === 'Manager' &&
      profileRole !== 'Manager' &&
      profileRole !== 'Administrator' &&
      profileRole !== 'Super Admin'
    ) {
      return true;
    }
    if (role === 'Administrator' && profileRole !== 'Administrator' && profileRole !== 'Super Admin') {
      return true;
    }

    return false;
  };

  return (
    <div className={style.permissionsStep}>
      <div className={style.metricsBlock}>
        <Select
          name={USER_FIELDS.TIMEZONE}
          control={control}
          label={t('Timezone')}
          options={timezoneList}
          itemKeys={{ valueFieldKey: 'id', labelFieldKey: 'title' }}
          required
        />
        <RadioButtonsGroup
          name={USER_FIELDS.DATETIME_FORMAT}
          control={control}
          label={t('Date format')}
          options={dateTimeList}
          type="column"
        />
        <RadioButtonsGroup
          name={USER_FIELDS.USE_METRIC}
          control={control}
          label={t('Measurement units')}
          options={metricsList}
          type="column"
        />
      </div>
      {/*{metric === 2 && (*/}
      {/*  <div className={style.metricsBlockCustom}>*/}
      {/*    {chartTypeListData.map((type) => (*/}
      {/*      <RadioButtonsGroup*/}
      {/*        key={type.alias}*/}
      {/*        name={`${USER_FIELDS.UNITS}.${type.readingTypes[0]}`}*/}
      {/*        control={control}*/}
      {/*        label={t(type.label)}*/}
      {/*        options={Object.keys(type.unitsList).map((key) => ({*/}
      {/*          value: key,*/}
      {/*          label: type.unitsList[key],*/}
      {/*        }))}*/}
      {/*        type="row"*/}
      {/*      />*/}
      {/*    ))}*/}
      {/*  </div>*/}
      {/*)}*/}
      <div>
        <label className={cx(style.fieldLabel, style.required)}>{t('User permissions')}</label>
        <div className={style.userRoleBlock}>
          {roleAndPermissionList.map((rolePermission) => (
            <label
              key={rolePermission.value}
              className={cx(style.roleItem, {
                [style.activeRoleItem]: rolePermission.value === roleValue,
                [style.disabledRoleItem]: checkDisabledRole(rolePermission.role),
              })}
              onClick={() => roleChange(rolePermission.value)}
            >
              <div className={style.itemBtn}>
                <input
                  name="user-role"
                  type="radio"
                  className={style.itemInput}
                  value={rolePermission.value}
                  disabled={rolePermission.disabled}
                  defaultChecked={rolePermission.value === roleValue}
                />
              </div>
              <div
                className={cx(style.roleItemName, {
                  [style.activeRoleItemName]: rolePermission.value === roleValue,
                })}
              >
                {t(rolePermission.role)}
              </div>
              <div className={style.roleItemDescription}>{t(rolePermission.description)}</div>
            </label>
          ))}
        </div>
      </div>
      {hasViewSensorDataPermission && (
        <div className={style.switchBlock}>
          <Switch
            name={USER_FIELDS.VIEW_SENSOR_DATA_PERMISSION}
            control={control}
            label={t('Allow user to view sensor data')}
          />
        </div>
      )}
    </div>
  );
};

export default StepRegionAndPermissions;
